import "./Lookbook.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import LookbookGallery from "./sections/LookbookGallery";
import GalleryFilters from "./sections/GalleryFilters";
import Footer from "@/reusable_sections/Footer";
export default function LookbookPage() {
  return <div>
      <Header />
      <Hero />
      <LookbookGallery />
      <GalleryFilters />
      <Footer />
    </div>;
}